import { gsap } from 'gsap';

const body = document.querySelector('body');
const topBar = document.querySelector('.top-bar');
const masthead = document.querySelector('header.masthead');
const inner = document.querySelector('.masthead__inner');

const classFixed = 'masthead--fixed';
const classVisible = 'masthead--visible';

let lastScrollY = window.scrollY;

const handleScrollDirection = () => {
    if (masthead.classList.contains(classFixed)) {
        const currentScrollY = window.scrollY;

        // scrolling up
        if (currentScrollY < lastScrollY) {
            if (!masthead.classList.contains(classVisible)) {
                masthead.classList.add(classVisible);
                gsap.to(inner, { y: '100%', duration: 0.3, ease: 'power2.out' });
            }
        }

        // scrolling down
        else if (currentScrollY > lastScrollY) {
            if (!body.classList.contains('show-menu')) {
                if (masthead.classList.contains(classVisible)) {
                    masthead.classList.remove(classVisible);
                    gsap.to(inner, { y: '0%', duration: 0.3, ease: 'power2.in' });
                }
            }
        }

        lastScrollY = currentScrollY;
    }
};

const showObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            masthead.classList.add(classFixed);
            window.addEventListener('scroll', handleScrollDirection, { passive: true });
        }
    });
}, { threshold: 0 });

const hideObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            gsap.killTweensOf(inner);

            masthead.classList.remove(classFixed, classVisible);
            window.removeEventListener('scroll', handleScrollDirection);

            gsap.set(inner, { clearProps: 'transform' });

            lastScrollY = window.scrollY;
        }
    });
}, { threshold: 0 });

showObserver.observe(masthead);
hideObserver.observe(topBar);
